<template>
  <div id="login">
    <div class="d-flex flex-column">
      <div>
        <h4 class="pl-4 font-weight-bolder">Connexion</h4>
        <b-form class="pl-4 pr-4" @submit="onLogin">
          <b-form-input
            v-model="email"
            :class="{'border-danger': inputError, }"
            class="border mb-3"
            id="email-login"
            type="text"
            placeholder="Email"
          ></b-form-input>
          <b-form-input
            v-model="password"
            :class="{'border-danger': inputError}"
            class="border mb-3"
            id="password-login"
            type="password"
            placeholder="Mot de passe"
          ></b-form-input>
          <p class="text-danger" v-if="inputError">
            Votre email ou mot de passe est incorrect !
          </p>
          <b-button @click="onLogin" class="mb-2 mx-auto button-cta-primary w-100">
            Connexion
          </b-button>
        </b-form>
        <div class="text-small text-center">
          Vous n'avez pas de compte ? <br>
          <router-link to="/signup" class="signup-now">
            Créez en un gratuitement !
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'

export default {
  name: 'login',
  data () {
    return {
      email: '',
      password: '',
      inputError: false
    }
  },
  methods: {
    onLogin: function () {
      firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(
        (user) => {
          this.inputError = false
          this.$router.replace('home')
        },
        (err) => {
          this.inputError = true
          console.log(err)
        }
      )
    }
  }
}
</script>

<style>
  .signup-now {
    color: #3AAFB4;
    font-weight: 500;
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// src/views/LoginComponent.vue